import { render } from "./ReferenceProfileAlignmentModal.vue?vue&type=template&id=47b87a21&scoped=true"
import script from "./ReferenceProfileAlignmentModal.vue?vue&type=script&lang=js"
export * from "./ReferenceProfileAlignmentModal.vue?vue&type=script&lang=js"

import "./ReferenceProfileAlignmentModal.vue?vue&type=style&index=0&id=47b87a21&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b87a21"]])

export default __exports__